import ym from 'react-yandex-metrika';

export default function sendLessonYaMetrika(me, params) {
    const { courseId = null, clessonId = null } = params;
    let role;

    if (me && me.is_content_manager) {
        role = 'cm';
    } else {
        role = me && me.is_teacher ? 'teacher' : 'student';
    }

    ym('userParams', {
        role,
        courseId,
        clessonId,
    });
}
